__turbopack_context__.v({
  "account-link": "header-module-scss-module__5Hk6NG__account-link",
  "contact-link": "header-module-scss-module__5Hk6NG__contact-link",
  "header": "header-module-scss-module__5Hk6NG__header",
  "home-link": "header-module-scss-module__5Hk6NG__home-link",
  "logo": "header-module-scss-module__5Hk6NG__logo",
  "nav": "header-module-scss-module__5Hk6NG__nav",
  "placeholder": "header-module-scss-module__5Hk6NG__placeholder",
  "search-link": "header-module-scss-module__5Hk6NG__search-link",
});
